// This file was automatically generated from appchart.refpanel.intols.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.intols');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.ptIntolerances');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.intols.intoleranceList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isDocumentedAsNone) {
    output.append('<li class="el8ItemHover intolActive more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p>');
    el8.template.ptdata.ptIntolerances.documentedAsNoneSummary(null, output);
    output.append('</p></li>');
  } else {
    if (! opt_data.actives.length && ! opt_data.inactives.length) {
      output.append('<p></p>');
    } else {
      var aList5313 = opt_data.actives;
      var aListLen5313 = aList5313.length;
      for (var aIndex5313 = 0; aIndex5313 < aListLen5313; aIndex5313++) {
        var aData5313 = aList5313[aIndex5313];
        el8.template.appchart.refpanel.intols.intolerance(aData5313, output);
      }
      var aList5316 = opt_data.inactives;
      var aListLen5316 = aList5316.length;
      for (var aIndex5316 = 0; aIndex5316 < aListLen5316; aIndex5316++) {
        var aData5316 = aList5316[aIndex5316];
        el8.template.appchart.refpanel.intols.intolerance(aData5316, output);
      }
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.intols.intolerance = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.id), '" class="el8ItemHover intol', soy.$$escapeHtml(opt_data.status), ' more-actions-trigger am-highlight"><div class="el8ItemButtonContainer"><button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button></div><p><span class="edit-text-trigger el8EditableText el8Preserve" data-id="', soy.$$escapeHtml(opt_data.id), '">');
  el8.template.ptdata.ptIntolerances.summary(opt_data, output);
  output.append('<span class="el8EditIcon"></span></span></p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.intols.addNewTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSButtonContainer"><p>', (opt_data.isNotDocumented) ? '<button type="button" class="el8button document-none-trigger el8ItemButton el8Show ebs-btn ebs-btn-default">None</button><span class="padh10">or</span>' : '', '<button type="button" class="el8button add-intol-trigger el8ItemButton el8Show ebs-btn ebs-btn-default">+ Add Drug Intolerance</button></p></div>');
  if (!opt_sb) return output.toString();
};
